import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';

import { Button, Input, Textarea } from './';

export default function Form({
  fieldList,
  initialFieldValues,
  buttonText,
  handleSubmit,
  validationSchema,
}) {
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isSubmitted) {
      setIsSubmitted(false);
      return navigate('/');
    }
  }, [isSubmitted]);

  const formik = useFormik({
    enableReintialize: true,
    initialValues: initialFieldValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values, setIsSubmitted);
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      {fieldList.map((field) => (
        <div className="mt-4" key={field.name}>
          {field.textarea ? (
            <Textarea
              field={field}
              value={formik.values?.[field.name]}
              handleChange={formik.handleChange}
              touched={formik.touched?.[field.name]}
              error={formik.errors?.[field.name]}
            />
          ) : (
            <Input
              field={field}
              value={formik.values?.[field.name]}
              handleChange={formik.handleChange}
              touched={formik.touched?.[field.name]}
              error={formik.errors?.[field.name]}
            />
          )}
        </div>
      ))}
      <div className="mt-5">
        <Button
          label={buttonText}
          // disabled={isSubmitting}
        />
      </div>
    </form>
  );
}
